// utils/suppliers.js

export const createSupplierPayload = (values, user, existingId = null) => {

  const payload = {
    acc_id: existingId ? existingId : values.acc_id,
    action: existingId ? "update" : "create",

    acc_code: values.acc_code,
    acc_name: values.acc_name?.trim(),

    acc_type: {
      acc_type_name: "Supplier",
      acc_type_id: "creditor",
      label: "Supplier",
    },
    acc_type_id: "creditor",
    acc_type_name: "Supplier",

    institution_name: values.institution_name || "",
    address: values.address || "",
    contact_no: values.contact_no || "",
    country_code: values.country_code || "1",
    country: values.country || "",
    po_box: values.po_box || "",
    acc_mgr: values.acc_mgr || "",
    institution_owner: Array.isArray(values.institution_owner)
      ? values.institution_owner.join(",")
      : values.institution_owner || "",

    licence_no: values.licence_no || "",
    licence_validity: values.licence_validity || "",

    opening_balance: values.opening_balance || 0,
    credit_limit: values.credit_limit || 0,
    budget: values.budget || 0,
    email_address: values.email_address || "",

    location_id: values.location_id || 0,
    employee_id: values.employee_id || 0,

    bank_acc_name: values.bank_acc_name || "",
    bank_acc_number: values.bank_acc_number || "",
    bank_acc_type: values.bank_acc_type || "",
    bank_branch: values.bank_branch || "",

    party_type: values.party_type || "no",
    conversation: values.conversation || "",
    expectation_per: values.expectation_per || "",
    vat_no: values.vat_no || "",

    office_country_code: values.office_country_code || "",
    office_contact_no: values.office_contact_no || "",
    salesman_country_code: values.salesman_country_code || "",
    salesman_contact_no: values.salesman_contact_no || "",
    salesman_name: values.salesman_name || "",
    contact_person: values.contact_person_name || "",
    gst_type: values.gst_type,
    province: values.state || "",
    gln_no: values.gln_no || "",
    is_also_debitor: values.is_also_debitor ? 1 : 0,
    customer_opening_balance: Number(values.customer_opening_balance || 0),
    // pass linked_acc_id if editing and already linked
    linked_acc_id: values.linked_acc_id || null,
    company_prefix_length: values.company_prefix_length,
  };

  // 🟢 Handle Credit Time & Count
  if (values.credit_time === "months" && values.credit_count > 0) {
    payload.credit_month = values.credit_count;
  } else if (values.credit_time === "days" && values.credit_count > 0) {
    payload.credit_day = values.credit_count;
  }

  return payload;
};
